module.exports = __webpack_public_path__ + "img/22.f320cb15.png";